import { useEffect } from "react";

// 215: pravidelné načítání jen na viditelné kartě (schovaná karta nezatěžuje server);
// po návratu na kartu se data načtou hned.
export function useVisiblePolling(load, ms) {
  useEffect(() => {
    load();
    const id = setInterval(() => { if (document.visibilityState === "visible") load(); }, ms);
    const onVis = () => { if (document.visibilityState === "visible") load(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVis); };
  }, [load, ms]);
}
